<template>
  <div :class="widgetData.container" id="location_region_detail">
    <div class="row mb-5" v-if="placeLocation.attractions && placeLocation.attractions.length > 0">
      <div class="col-12">
        <div class="section-title">
          <h2>{{ $t('attractions-in-region') }}</h2>
        </div>

        <div class="row">
          <div class="col-md-4 col-lg-3 location_region_detail_attractions mb-3 card-group" v-for="attraction in placeLocation.attractions">
            <div class="card">
              <NuxtLink :to="attractionLang(attraction)">
                <div class="card-header p-0">
                  <figure class="pointer mb-0">
                    <picture>
                      <PartsSrcSetImage v-if="attraction.hasImage()" :image="attraction.getTopImage()" :t_type="'thumbw'"
                                        :type="'webp'"/>
                      <PartsSrcSetImage v-if="attraction.hasImage()" :image="attraction.getTopImage()" :t_type="'thumbw'"
                                        :type="'jpeg'"/>

                      <img v-if="attraction.hasImage()"
                           :src="attraction.getTopImage().getTyrionSrc('thumbw')"
                           :alt="attraction.getTopImage().title" class="img-cover img-attraction" loading="lazy"
                           :width="attraction.getTopImage().seoWidth('thumb')" :height="attraction.getTopImage().seoHeight('thumb')">
                      <img v-else src="~/assets/img/blank.jpg" :alt="attraction.title" class="img-cover img-attraction" loading="lazy"
                           width="600" height="337">
                    </picture>
                  </figure>
                </div>
              </NuxtLink>

              <div class="card-body">
                <div class="row align-items-end d-flex">
                  <div class="col-12">
                    <p class="mb-0 h5">{{ attraction.title }}</p>
                    <span class="silver-for-text">{{ attraction.city.title }}</span>
                  </div>
                </div>
              </div>

              <div class="card-footer py-0">
                <div class="description my-3" v-if="typeof attraction.description === 'object' && attraction.description[activeLocale.code] !== undefined"
                     v-html="attraction.description[activeLocale.code].substr(0,350) + '...'"></div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, PropType, ref} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import "~/assets/less/location_region_detail_attractions.min.css";
import {useWidget} from "../../../../composables/widget/location";
import PlaceTouristRegion from "../../../../lib/models/PlaceTouristRegion";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content, location, activeLocale} = useWidget(props.widget);
const placeLocation = computed<PlaceTouristRegion>(() => location as PlaceTouristRegion)

const attractionLang = (attraction) => {
  return typeof attraction.page_urls === 'object' && attraction.page_urls[activeLocale.code] !== undefined ? `/${attraction.page_urls[activeLocale.code]}` : '#';
}
</script>
